export default __webpack_public_path__ + "static/media/barcode.ddc44448.png";